/*============================================================================
  Ajax the add to cart experience by revealing it in a side drawer
  Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
  (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  This file includes:
    - Basic Shopify Ajax API calls
    - Ajax cart plugin

  This requires:
    - jQuery 1.8+
    - handlebars.min.js (for cart template)
    - modernizr.min.js
    - snippet/ajax-cart-template.liquid

  Customized version of Shopify's jQuery API
  (c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
==============================================================================*/
if ((typeof ShopifyAPI) === 'undefined') { ShopifyAPI = {}; }

/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
  if ((typeof attribute) !== 'string') {
    attribute += '';
    if (attribute === 'undefined') {
      attribute = '';
    }
  }
  return jQuery.trim(attribute);
};

/*============================================================================
  API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function(cart) {
  // alert('There are now ' + cart.item_count + ' items in the cart.');
};

ShopifyAPI.updateCartNote = function(note, callback) {
  var $body = $(document.body),
  params = {
    type: 'POST',
    url: '/cart/update.js',
    data: 'note=' + attributeToString(note),
    dataType: 'json',
    beforeSend: function() {
      $body.trigger('beforeUpdateCartNote.ajaxCart', note);
    },
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
      $body.trigger('afterUpdateCartNote.ajaxCart', [note, cart]);
    },
    error: function(XMLHttpRequest, textStatus) {
      $body.trigger('errorUpdateCartNote.ajaxCart', [XMLHttpRequest, textStatus]);
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    },
    complete: function(jqxhr, text) {
      $body.trigger('completeUpdateCartNote.ajaxCart', [this, jqxhr, text]);
    }
  };
  jQuery.ajax(params);
};

ShopifyAPI.onError = function(XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    alert(data.message + '(' + data.status  + '): ' + data.description);
  }
};

/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
==============================================================================*/
ShopifyAPI.addItemFromForm = function(form, callback, errorCallback) {
  var $body = $(document.body),
  params = {
    type: 'POST',
    url: '/cart/add.js',
    data: jQuery(form).serialize(),
    dataType: 'json',
    beforeSend: function(jqxhr, settings) {
      $body.trigger('beforeAddItem.ajaxCart', form);
    },
    success: function(line_item) {
      if ((typeof callback) === 'function') {
        $('body').addClass('ajax-drawer-open');
        $('.ajaxcart-wrapper').addClass('ajax-cart--is-open');
        callback(line_item, form);        
      }
      else {
        ShopifyAPI.onItemAdded(line_item, form);       
      }
      $body.trigger('afterAddItem.ajaxCart', [line_item, form]);
    },
    error: function(XMLHttpRequest, textStatus) {
      if ((typeof errorCallback) === 'function') {
        errorCallback(XMLHttpRequest, textStatus);
      }
      else {
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      }
      $body.trigger('errorAddItem.ajaxCart', [XMLHttpRequest, textStatus]);
    },
    complete: function(jqxhr, text) {
      $body.trigger('completeAddItem.ajaxCart', [this, jqxhr, text]);
    }
  };
  jQuery.ajax(params);
  
   /* BOLD UPSELL AJAX CODE */
  if(typeof BOLD === 'object' && BOLD.common && BOLD.common.eventEmitter && typeof BOLD.common.eventEmitter.emit === 'function') {
    BOLD.common.eventEmitter.emit("BOLD_COMMON_cart_loaded");
    BOLD.common.eventEmitter.emit('BOLD_COMMON_redirect_upsell_product');
  }
};

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function(callback) {
  $(document.body).trigger('beforeGetCart.ajaxCart');
  jQuery.getJSON('/cart.js', function (cart, textStatus) {
    if ((typeof callback) === 'function') {
      callback(cart);
    }
    else {
      ShopifyAPI.onCartUpdate(cart);
    }
    $(document.body).trigger('afterGetCart.ajaxCart', cart);
    function getCook(cart_currency) 
    {
    // Get name followed by anything except a semicolon
    var cookiestring=RegExp(cart_currency+"=[^;]+").exec(document.cookie);
    // Return everything after the equal sign, or an empty string if the cookie name not found
    return decodeURIComponent(!!cookiestring ? cookiestring.toString().replace(/^[^=]+./,"") : "");
    }
  
  //Sample usage
    var cookieValue = getCook('cart_currency');

//     if (cookieValue === 'EUR') {
//         if (cart.total_price >= 5000) {
//             var cartItems = cart.items,
//             qtyInTheCart = 0,
//             cartUpdates = {},
//             cartTotal = cart.total_price;

//             for (var i=0; i < cartItems.length; i++) {
//             if ( cartItems[i].id === 17578365255751 ) {
//                 qtyInTheCart = cartItems[i].quantity;
//                 break;
//             }
//             else if ( ( cartItems.length >= 1 ) && ( qtyInTheCart !== 1 ) && (cartTotal >= 5000 ) ) {
//                 cartUpdates = { 17578365255751: + 1 }
//             }
            
//             }

//             // if ( ( cartItems.length === 1 ) && ( qtyInTheCart > 0 ) ) {
//             //     cartUpdates = { 17578365255751: 0 }
//             // }
//             // else if ( ( cartItems.length >= 1 ) && ( qtyInTheCart !== 1 ) && (cartTotal >= 7000 ) ) {
//             //     cartUpdates = { 17578365255751: 1 }
//             // }
//             // else {
//             //     return;
//             // }
//             var params = {
//             type: 'POST',
//             url: '/cart/update.js',
//             data: { updates: cartUpdates },
//             dataType: 'json',
//             success: function(data) { 
//                 callback(data);
//             }
//             };
//             $.ajax(params);
//         }
//     }

//     if (cookieValue === 'CAD') {
//         if (cart.total_price >= 8000) {
//             var cartItems = cart.items,
//             qtyInTheCart = 0,
//             cartUpdates = {},
//             cartTotal = cart.total_price;

//             for (var i=0; i < cartItems.length; i++) {
//             if ( cartItems[i].id === 17578365255751 ) {
//                 qtyInTheCart = cartItems[i].quantity;
//                 break;
//             }
//             else if ( ( cartItems.length >= 1 ) && ( qtyInTheCart !== 1 ) && (cartTotal >= 8000 ) ) {
//                 cartUpdates = { 17578365255751: + 1 }
//             }
            
//             }

//             // if ( ( cartItems.length === 1 ) && ( qtyInTheCart > 0 ) ) {
//             //     cartUpdates = { 17578365255751: 0 }
//             // }
//             // else if ( ( cartItems.length >= 1 ) && ( qtyInTheCart !== 1 ) && (cartTotal >= 7000 ) ) {
//             //     cartUpdates = { 17578365255751: 1 }
//             // }
//             // else {
//             //     return;
//             // }
//             var params = {
//             type: 'POST',
//             url: '/cart/update.js',
//             data: { updates: cartUpdates },
//             dataType: 'json',
//             success: function(data) { 
//                 callback(data);
//             }
//             };
//             $.ajax(params);
//         }
//     }

//     if (cookieValue === 'GBP') {
//         if (cart.total_price >= 4800) {
//             var cartItems = cart.items,
//             qtyInTheCart = 0,
//             cartUpdates = {},
//             cartTotal = cart.total_price;

//             for (var i=0; i < cartItems.length; i++) {
//             if ( cartItems[i].id === 17578365255751 ) {
//                 qtyInTheCart = cartItems[i].quantity;
//                 break;
//             }
//             else if ( ( cartItems.length >= 1 ) && ( qtyInTheCart !== 1 ) && (cartTotal >= 4800 ) ) {
//                 cartUpdates = { 17578365255751: + 1 }
//             }
            
//             }

//             // if ( ( cartItems.length === 1 ) && ( qtyInTheCart > 0 ) ) {
//             //     cartUpdates = { 17578365255751: 0 }
//             // }
//             // else if ( ( cartItems.length >= 1 ) && ( qtyInTheCart !== 1 ) && (cartTotal >= 7000 ) ) {
//             //     cartUpdates = { 17578365255751: 1 }
//             // }
//             // else {
//             //     return;
//             // }
//             var params = {
//             type: 'POST',
//             url: '/cart/update.js',
//             data: { updates: cartUpdates },
//             dataType: 'json',
//             success: function(data) { 
//                 callback(data);
//             }
//             };
//             $.ajax(params);
//         }
//     }

//     if (cookieValue === 'HKD') {
//         if (cart.total_price >= 46800) {
//             var cartItems = cart.items,
//             qtyInTheCart = 0,
//             cartUpdates = {},
//             cartTotal = cart.total_price;

//             for (var i=0; i < cartItems.length; i++) {
//             if ( cartItems[i].id === 17578365255751 ) {
//                 qtyInTheCart = cartItems[i].quantity;
//                 break;
//             }
//             else if ( ( cartItems.length >= 1 ) && ( qtyInTheCart !== 1 ) && (cartTotal >= 46800 ) ) {
//                 cartUpdates = { 17578365255751: + 1 }
//             }
            
//             }

//             // if ( ( cartItems.length === 1 ) && ( qtyInTheCart > 0 ) ) {
//             //     cartUpdates = { 17578365255751: 0 }
//             // }
//             // else if ( ( cartItems.length >= 1 ) && ( qtyInTheCart !== 1 ) && (cartTotal >= 7000 ) ) {
//             //     cartUpdates = { 17578365255751: 1 }
//             // }
//             // else {
//             //     return;
//             // }
//             var params = {
//             type: 'POST',
//             url: '/cart/update.js',
//             data: { updates: cartUpdates },
//             dataType: 'json',
//             success: function(data) { 
//                 callback(data);
//             }
//             };
//             $.ajax(params);
//         }
//     }

//     if (cookieValue === 'JPY') {
//         if (cart.total_price >= 650000) {
//             var cartItems = cart.items,
//             qtyInTheCart = 0,
//             cartUpdates = {},
//             cartTotal = cart.total_price;

//             for (var i=0; i < cartItems.length; i++) {
//             if ( cartItems[i].id === 17578365255751 ) {
//                 qtyInTheCart = cartItems[i].quantity;
//                 break;
//             }
//             else if ( ( cartItems.length >= 1 ) && ( qtyInTheCart !== 1 ) && (cartTotal >= 650000 ) ) {
//                 cartUpdates = { 17578365255751: + 1 }
//             }
            
//             }

//             // if ( ( cartItems.length === 1 ) && ( qtyInTheCart > 0 ) ) {
//             //     cartUpdates = { 17578365255751: 0 }
//             // }
//             // else if ( ( cartItems.length >= 1 ) && ( qtyInTheCart !== 1 ) && (cartTotal >= 7000 ) ) {
//             //     cartUpdates = { 17578365255751: 1 }
//             // }
//             // else {
//             //     return;
//             // }
//             var params = {
//             type: 'POST',
//             url: '/cart/update.js',
//             data: { updates: cartUpdates },
//             dataType: 'json',
//             success: function(data) { 
//                 callback(data);
//             }
//             };
//             $.ajax(params);
//         }
//     }

//     if (cookieValue === 'SGD') {
//         if (cart.total_price >= 8300) {
//             var cartItems = cart.items,
//             qtyInTheCart = 0,
//             cartUpdates = {},
//             cartTotal = cart.total_price;

//             for (var i=0; i < cartItems.length; i++) {
//             if ( cartItems[i].id === 17578365255751 ) {
//                 qtyInTheCart = cartItems[i].quantity;
//                 break;
//             }
//             else if ( ( cartItems.length >= 1 ) && ( qtyInTheCart !== 1 ) && (cartTotal >= 8300 ) ) {
//                 cartUpdates = { 17578365255751: + 1 }
//             }
            
//             }

//             // if ( ( cartItems.length === 1 ) && ( qtyInTheCart > 0 ) ) {
//             //     cartUpdates = { 17578365255751: 0 }
//             // }
//             // else if ( ( cartItems.length >= 1 ) && ( qtyInTheCart !== 1 ) && (cartTotal >= 7000 ) ) {
//             //     cartUpdates = { 17578365255751: 1 }
//             // }
//             // else {
//             //     return;
//             // }
//             var params = {
//             type: 'POST',
//             url: '/cart/update.js',
//             data: { updates: cartUpdates },
//             dataType: 'json',
//             success: function(data) { 
//                 callback(data);
//             }
//             };
//             $.ajax(params);
//         }
//     }

//     if (cookieValue === 'USD') {
//         if (cart.total_price >= 6300) {
//             var cartItems = cart.items,
//             qtyInTheCart = 0,
//             cartUpdates = {},
//             cartTotal = cart.total_price;

//             for (var i=0; i < cartItems.length; i++) {
//             if ( cartItems[i].id === 17578365255751 ) {
//                 qtyInTheCart = cartItems[i].quantity;
//                 break;
//             }
//             else if ( ( cartItems.length >= 1 ) && ( qtyInTheCart !== 1 ) && (cartTotal >= 6300 ) ) {
//                 cartUpdates = { 17578365255751: + 1 }
//             }
            
//             }

//             // if ( ( cartItems.length === 1 ) && ( qtyInTheCart > 0 ) ) {
//             //     cartUpdates = { 17578365255751: 0 }
//             // }
//             // else if ( ( cartItems.length >= 1 ) && ( qtyInTheCart !== 1 ) && (cartTotal >= 7000 ) ) {
//             //     cartUpdates = { 17578365255751: 1 }
//             // }
//             // else {
//             //     return;
//             // }
//             var params = {
//             type: 'POST',
//             url: '/cart/update.js',
//             data: { updates: cartUpdates },
//             dataType: 'json',
//             success: function(data) { 
//                 callback(data);
//             }
//             };
//             $.ajax(params);
//         }
//     }

//     if (cookieValue === 'DKK') {
//         if (cart.total_price >= 38000) {
//             var cartItems = cart.items,
//             qtyInTheCart = 0,
//             cartUpdates = {},
//             cartTotal = cart.total_price;

//             for (var i=0; i < cartItems.length; i++) {
//             if ( cartItems[i].id === 17578365255751 ) {
//                 qtyInTheCart = cartItems[i].quantity;
//                 break;
//             }
//             else if ( ( cartItems.length >= 1 ) && ( qtyInTheCart !== 1 ) && (cartTotal >= 38000 ) ) {
//                 cartUpdates = { 17578365255751: + 1 }
//             }
            
//             }

//             // if ( ( cartItems.length === 1 ) && ( qtyInTheCart > 0 ) ) {
//             //     cartUpdates = { 17578365255751: 0 }
//             // }
//             // else if ( ( cartItems.length >= 1 ) && ( qtyInTheCart !== 1 ) && (cartTotal >= 7000 ) ) {
//             //     cartUpdates = { 17578365255751: 1 }
//             // }
//             // else {
//             //     return;
//             // }
//             var params = {
//             type: 'POST',
//             url: '/cart/update.js',
//             data: { updates: cartUpdates },
//             dataType: 'json',
//             success: function(data) { 
//                 callback(data);
//             }
//             };
//             $.ajax(params);
//         }
//     }
  });
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function(line, quantity, callback) {
  var $body = $(document.body),
  params = {
    type: 'POST',
    url: '/cart/change.js',
    data: 'quantity=' + quantity + '&line=' + line,
    dataType: 'json',
    beforeSend: function() {
      $body.trigger('beforeChangeItem.ajaxCart', [line, quantity]);
    },
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
      $body.trigger('afterChangeItem.ajaxCart', [line, quantity, cart]);
    },
    error: function(XMLHttpRequest, textStatus) {
      $body.trigger('errorChangeItem.ajaxCart', [XMLHttpRequest, textStatus]);
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    },
    complete: function(jqxhr, text) {
      $body.trigger('completeChangeItem.ajaxCart', [this, jqxhr, text]);
    }
  };
  jQuery.ajax(params);
};

/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function(module, $) {

  'use strict';

  // Public functions
  var init, loadCart;

  // Private general variables
  var settings, isUpdating, $body;

  // Private plugin variables
  var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer, $drawerContainer;

  // Private functions
  var updateCountPrice, formOverride, itemAddedCallback, itemErrorCallback, cartUpdateCallback, buildCart, cartCallback, adjustCart, adjustCartCallback, createQtySelectors, qtySelectors, validateQty;

  /*============================================================================
    Initialise the plugin and define global options
  ==============================================================================*/
  init = function (options) {

    // Default settings
    settings = {
      formSelector       : 'form[action^="/cart/add"]',
      cartContainer      : '#CartContainer',
      addToCartSelector  : 'input[type="submit"]',
      cartCountSelector  : null,
      cartCostSelector   : null,
      moneyFormat        : '$',
      disableAjaxCart    : false,
      enableQtySelectors : true
    };

    // Override defaults with arguments
    $.extend(settings, options);

    // Select DOM elements
    $formContainer     = $(settings.formSelector);
    $cartContainer     = $(settings.cartContainer);
    $addToCart         = $formContainer.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector  = $(settings.cartCostSelector);

    // General Selectors
    $body = $(document.body);

    // Track cart activity status
    isUpdating = false;

    // Setup ajax quantity selectors on the any template if enableQtySelectors is true
    if (settings.enableQtySelectors) {
      qtySelectors();
    }

    // Take over the add to cart form submit action if ajax enabled
    if (!settings.disableAjaxCart && $addToCart.length) {
      formOverride();
    }

    // Run this function in case we're using the quantity selector outside of the cart
    adjustCart();
  };

  loadCart = function () {
    //$body.addClass('drawer--is-loading');
    ShopifyAPI.getCart(cartUpdateCallback);
  };

  updateCountPrice = function (cart) {
    if ($cartCountSelector) {
      $cartCountSelector.html(cart.item_count).removeClass('hidden-count');

      if (cart.item_count === 0) {
        $cartCountSelector.addClass('hidden-count');
      }
    }
    if ($cartCostSelector) {
      $cartCostSelector.html(Shopify.formatMoney(cart.total_price, settings.moneyFormat));
    }
  };

  formOverride = function () {
    $formContainer.on('submit', function(evt) {
      evt.preventDefault();

      // Add class to be styled if desired
      $addToCart.removeClass('is-added').addClass('is-adding');

      // Remove any previous quantity errors
      $('.qty-error').remove();

      ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback);
    });
  };

  itemAddedCallback = function (product) {
    $addToCart.removeClass('is-adding').addClass('is-added');

    ShopifyAPI.getCart(cartUpdateCallback);
  };

  itemErrorCallback = function (XMLHttpRequest, textStatus) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    $addToCart.removeClass('is-adding is-added');

    if (!!data.message) {
      if (data.status == 422) {
        $formContainer.after('<div class="errors qty-error">'+ data.description +'</div>')
      }
    }
  };

  cartUpdateCallback = function (cart) {
    // Update quantity and price
    updateCountPrice(cart);
    buildCart(cart);
  };

  buildCart = function (cart) {
    // Start with a fresh cart div
    $cartContainer.empty();

    // Show empty cart
    if (cart.item_count === 0) {
      $('#CartProduct').addClass('hide');
      $('#fsb_placeholder').addClass('hide');
      $('#CartCount').addClass('hide');
      
      $cartContainer
        .append('<p>' + "Your bag is currently empty." + '</p>');
      $cartContainer
        .append('<a class="btn" href="/">' + "Continue shopping" + '</a>');
      $cartContainer.addClass('ajaxcart-empty');
      //$('#CartProduct').addClass('hide');
      cartCallback(cart);
      return;
    }
    $('#CartProduct').removeClass('hide');
    $('#fsb_placeholder').removeClass('hide');
    $('#CartCount').removeClass('hide');
	$cartContainer.removeClass('ajaxcart-empty');
    // Handlebars.js cart layout
    var items = [],
        item = {},
        data = {},
        source = $("#CartTemplate").html(),
        template = Handlebars.compile(source);

    // Add each item to our handlebars.js data
    $.each(cart.items, function(index, cartItem) {

      /* Hack to get product image thumbnail
       *   - If image is not null
       *     - Remove file extension, add _small, and re-add extension
       *     - Create server relative link
       *   - A hard-coded url of no-image
      */
      if (cartItem.image != null){
        var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_small$1").replace('http:', '');
      } else {
        var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
      }

      // Create item's data object and add to 'items' array
      item = {
        key: cartItem.key,
        line: index + 1, // Shopify uses a 1+ index in the API
        url: cartItem.url,
        img: prodImg,
        name: cartItem.product_title,
        variation: cartItem.variant_title,
        properties: cartItem.properties,
        itemAdd: cartItem.quantity + 1,
        itemMinus: cartItem.quantity - 1,
        itemQty: cartItem.quantity,
        price: Shopify.formatMoney(cartItem.price, settings.moneyFormat),
        vendor: cartItem.vendor,
        linePrice: Shopify.formatMoney(cartItem.line_price, settings.moneyFormat),
        originalLinePrice: Shopify.formatMoney(cartItem.original_line_price, settings.moneyFormat),
        discounts: cartItem.discounts,
        discountsApplied: cartItem.line_price === cartItem.original_line_price ? false : true,
        variantId: cartItem.variant_id,
        backorderMsg: backorder_msg != null ? backorder_msg[cartItem.variant_id] : ""
  
      };

      items.push(item);
    });

    // Gather all cart data and add to DOM
    var  freeShip = "45";
    data = {
      items: items,
      note: cart.note,
      totalPrice: Shopify.formatMoney(cart.total_price, settings.moneyFormat),
      totalCartDiscount: cart.total_discount === 0 ? 0 : "translation missing: en.cart.general.savings_html".replace('[savings]', Shopify.formatMoney(cart.total_discount, settings.moneyFormat)),
      totalCartDiscountApplied: cart.total_discount === 0 ? false : true,
      shippingMessageHTML: cart.total_price < freeShip * 100 ? "You're <strong>" +  Shopify.formatMoney(freeShip * 100 - cart.total_price, settings.moneyFormat) + '</strong> ' + 'away from free shipping!' : 'You have qualified for Free Shipping'
    }

    $cartContainer.append(template(data));

    cartCallback(cart);
  };
    
  cartCallback = function(cart) {
    $body.removeClass('drawer--is-loading');
    $body.trigger('afterCartLoad.ajaxCart', cart);

    if (window.Shopify && Shopify.StorefrontExpressButtons) {
      Shopify.StorefrontExpressButtons.initialize();
    }
    
      
    //console.log('This is the cart on update event!');
    const protectionContainer = document.querySelector('#shippingProtection');
    if (protectionContainer) {
      protectionContainer.addEventListener('change', (event) => {
        if (event.currentTarget.checked) {
          window.localStorage.setItem('noshipping', false);
          window.localStorage.setItem('counter', 1);
          addShippingToCart();
          // cart refreshes in function above
        } else {
          window.localStorage.setItem('noshipping', true);
          window.localStorage.setItem('counter', 1);
          removeShippingFromCart();
          // cart refreshes in function above
        }
      });
    }
  
    
    //DESIRED UX SETUP
    let hasShipping = cart.items.filter((cartItem) => {
      if (cartItem.id === 39270743408813) {
      	return cartItem;
      }
    });
    if (hasShipping.length == 0 && cart.items.length > 0 && localStorage.getItem('counter') === '0') {
      addShippingToCart();
    }
    if (hasShipping.length > 0) {
      $('#shippingProtection').prop( "checked", true );
    } else if (hasShipping.length === 0) {
      $('#shippingProtection').prop( "checked", false );
    }
    
    //if cart has more then 1 item, has no shipping, and localStorage.counter is 0
    // 	add shipping to cart
    //if cart has Shippng Insurance
    //	get the chebox to true
    //if customer removes Shipping
    //	get localStorage.counter to 1
   
    $('#CartCount').text(cart.items.length);
  
  	const theContainer = document.querySelector('.spModal__container');
   	const shippingInfoBtn = document.querySelector('.shippingInfo-trigger');
  	if (shippingInfoBtn) {
      shippingInfoBtn.addEventListener('click', (event) => {
        // Show a modal
        theContainer.classList.add('active'); 
      });
    }
      
  };

                
  function addShippingToCart() {
  	let data = {
      "id": "39270743408813",
      "quantity": 1
    }
    
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data:data,
      dataType: 'json',
      success: function(item) {
        let oldNumber = parseInt($('#CartCount').text());
        $('#CartCount').text(oldNumber + 1);

        $('#shippingProtection').prop( "checked", true );
        
          
        const cartItemHtml = '<div class="ajaxcart__product" data-item-thing="Shipping Insurance"><div class="ajaxcart__row" data-line="1"><div class="grid"><div class="grid__item three-tenths"><a href="/products/shipping-insurance?variant=39270743408813" class="ajaxcart__product-image"><img src="https://cdn.shopify.com/s/files/1/2202/8645/products/InsuranceIcons-02_2x_9fbe1394-bf3b-4470-9ee1-33674b0ef416_small.png?v=1614202604" alt=""></a></div><div class="grid__item seven-tenths"><p><a href="/products/shipping-insurance?variant=39270743408813" class="ajaxcart__product-name">Shipping Insurance</a></p><div class="ajaxcart-price"><span><span class="money">&#8364;1.50</span></span></div><div class="ajaxcart__qty"><div type="button" class="ajaxcart__qty-adjust ajaxcart__qty--minus icon-fallback-text" data-id="" data-qty="0" data-line="1"><span class="fallback-text" aria-hidden="true">−</span><span class="visually-hidden">translation missing: en.cart.general.reduce_quantity</span></div><input type="text" name="updates[]" class="ajaxcart__qty-num" value="1" min="0" data-id="" data-line="1" aria-label="quantity" pattern="[0-9]*"><div type="button" class="ajaxcart__qty-adjust ajaxcart__qty--plus icon-fallback-text" data-id="" data-line="1" data-qty="2"><span class="fallback-text" aria-hidden="true">+</span><span class="visually-hidden">translation missing: en.cart.general.increase_quantity</span></div></div><div class="close-icon"><a href="/cart/change?line=1&amp;quantity=0" class="close-icon" title="Remove">Remove</a></div></div></div></div></div>';
        const cartNode = document.createRange().createContextualFragment(cartItemHtml);
        const sibblingNode = document.querySelector('.ajaxcart__product:first-child');
        document.querySelector('.ajaxcart__inner').insertBefore(cartNode, sibblingNode );
        // update price 
        let price = document.querySelector('.cart-gtotal-footer p').innerText;
        let newPrice = parseFloat(price.split(' ')[0].split('$').join(''));
        
        const shippingRemoveLink = document.querySelector('div[data-item-thing="Shipping Insurance"] a.close-icon');
        if (shippingRemoveLink) {
          shippingRemoveLink.setAttribute("href", "#");
          shippingRemoveLink.addEventListener('click', (event) => {
            event.preventDefault();
            event.target.removeEventListener('click');
            // Change check to off
            $('#shippingProtection').prop( "checked", false );
            window.localStorage.setItem('counter', 1);
            //document.getElementById("shippingProtection").click();
            ShopifyAPI.getCart(cartUpdateCallback);
          });
        }
        window.localStorage.setItem('counter', 1);
        ShopifyAPI.getCart(cartUpdateCallback);
      }
    })
  }

  function removeShippingFromCart() {
    let data = {
      "id": "39270743408813",
      "quantity": 0
    }

    jQuery.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data:data,
      dataType: 'json',
      success: function() {
        document.querySelector('div[data-item-thing="Shipping Insurance"]').remove();
        window.localStorage.setItem('counter', 1);
        ShopifyAPI.getCart(cartUpdateCallback);
      }
    })
  }

  adjustCart = function () {
    // Delegate all events because elements reload with the cart

    // Add or remove from the quantity
    $body.on('click', '.ajaxcart__qty-adjust', function() {
      if (isUpdating) {
        return;
      }

      var $el = $(this),
          line = $el.data('line'),
          $qtySelector = $el.siblings('.ajaxcart__qty-num'),
          qty = parseInt($qtySelector.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // Add or subtract from the current quantity
      if ($el.hasClass('ajaxcart__qty--plus')) {
        qty += 1;
      } else {
        qty -= 1;
        if (qty <= 0) qty = 0;
      }

      // If it has a data-line, update the cart.
      // Otherwise, just update the input's number
      if (line) {
        $qtySelector.val(qty);
        updateQuantity(line, qty);
      } else {
        $qtySelector.val(qty);
      }
    }); 
    
    
    const theContainer = document.querySelector('.spModal__container');
    const theOverlay = document.querySelector('.spModal__overlay');
    if (theContainer && theOverlay) {
    theOverlay.addEventListener('click', (event) => {
         theContainer.classList.remove('active');  
      })
      const shippingModalCloseBtn = document.querySelector('.spModal__close');
      if (shippingModalCloseBtn) {
        shippingModalCloseBtn.addEventListener('click', (event) => {
          // Show a modal
          theContainer.classList.remove('active'); 
        });
      }
    }

    // Update quantity based on input on change
    $body.on('change', '.ajaxcart__qty-num', function() {
      if (isUpdating) {
        return;
      }

      var $el = $(this),
          line = $el.data('line'),
          qty = parseInt($el.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // If it has a data-line, update the cart
      if (line) {
        updateQuantity(line, qty);
      }
    });

    // Prevent cart from being submitted while quantities are changing
    $body.on('submit', 'form.ajaxcart', function(evt) {
      if (isUpdating) {
        evt.preventDefault();
      }
    });

    // Highlight the text when focused
    $body.on('focus', '.ajaxcart__qty-adjust', function() {
      var $el = $(this);
      setTimeout(function() {
        $el.select();
      }, 50);
    });

    function updateQuantity(line, qty) {
      isUpdating = true;

      // Add activity classes when changing cart quantities
      var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass('is-loading');

      if (qty === 0) {
        $row.parent().addClass('is-removed');
      }

      // Slight delay to make sure removed animation is done
      setTimeout(function() {
        ShopifyAPI.changeItem(line, qty, adjustCartCallback);
      }, 250);
    }

    // Save note anytime it's changed
    $body.on('change', 'textarea[name="note"]', function() {
      var newNote = $(this).val();

      // Update the cart note in case they don't click update/checkout
      ShopifyAPI.updateCartNote(newNote, function(cart) {});
    });
  };

  adjustCartCallback = function (cart) {
    // Update quantity and price
    updateCountPrice(cart);

    // Reprint cart on short timeout so you don't see the content being removed
    setTimeout(function() {
      isUpdating = false;
      ShopifyAPI.getCart(buildCart);
    }, 150)
  };

  createQtySelectors = function() {
    // If there is a normal quantity number field in the ajax cart, replace it with our version
    if ($('input[type="number"]', $cartContainer).length) {
      $('input[type="number"]', $cartContainer).each(function() {
        var $el = $(this),
            currentQty = $el.val();

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#AjaxQty").html(),
            template = Handlebars.compile(source),
            data = {
              key: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });
    }
  };

  qtySelectors = function() {
    // Change number inputs to JS ones, similar to ajax cart but without API integration.
    // Make sure to add the existing name and id to the new input element
    var numInputs = $('input[type="number"]');

    if (numInputs.length) {
      numInputs.each(function() {
        var $el = $(this),
            currentQty = $el.val(),
            inputName = $el.attr('name'),
            inputId = $el.attr('id');

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#JsQty").html(),
            template = Handlebars.compile(source),
            data = {
              key: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus,
              inputName: inputName,
              inputId: inputId
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });

      // Setup listeners to add/subtract from the input
      $('.js-qty__adjust').on('click', function() {
        var $el = $(this),
            id = $el.data('id'),
            $qtySelector = $el.siblings('.js-qty__num'),
            qty = parseInt($qtySelector.val().replace(/\D/g, ''));

        var qty = validateQty(qty);

        // Add or subtract from the current quantity
        if ($el.hasClass('js-qty__adjust--plus')) {
          qty += 1;
        } else {
          qty -= 1;
          if (qty <= 1) qty = 1;
        }

        // Update the input's number
        $qtySelector.val(qty);
      });
    }
  };

  validateQty = function (qty) {
    if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }
    return qty;
  };

  module = {
    init: init,
    load: loadCart
  };

  return module;

}(ajaxCart || {}, jQuery));
